import React from 'react'
import { IExternalTransaction } from '../../core/response.types'
import { convertUTCtoMSK } from '../../../../../../../utils'

interface ExternalTransactionSummaryProps {
  transaction: IExternalTransaction
}

interface SummaryField {
  label: string
  value: string | number | undefined | null
}

export const ExternalTransactionSummary: React.FC<ExternalTransactionSummaryProps> = ({
  transaction,
}) => {
  const fields: SummaryField[] = [
    { label: 'ID транзакции', value: transaction.id },
    { label: 'ID тикета', value: transaction.token || '—' },
    { label: 'Статус', value: transaction.status || '—' },
    { label: 'Провайдер', value: transaction.provider || '—' },
    { label: 'Мерчант', value: transaction.merchant || '—' },
    { label: 'ID адаптера', value: transaction.payment_id || '—' },
    { label: 'Создан', value: convertUTCtoMSK(transaction.created_at) },
    { label: 'Обновлён', value: convertUTCtoMSK(transaction.updated_at) },
  ]

  return (
    <div className='card mb-7'>
      <div className='card-header border-0 pt-5 pb-2'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-5 mb-1'>Информация о транзакции</span>
        </h3>
      </div>
      <div className='card-body pt-3'>
        <div className='row g-4'>
          {fields.map((field) => (
            <div key={field.label} className='col-md-3 col-sm-6'>
              <div className='fw-bold text-muted fs-7 mb-1'>{field.label}</div>
              <div className='fs-6' style={{ wordBreak: 'break-all' }}>
                {field.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
